import { LitElement, html, css, nothing } from 'lit';

import { Clamp } from '../../modules/Clamp';

import '../style-modules/katapult-scrollbars.js';

export const ScrollbarStyle = css`
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background: var(--paper-grey-200);
  }

  ::-webkit-scrollbar-track {
    /* -webkit-box-shadow: inset 0 0 3px #717271; */
  }

  ::-webkit-scrollbar-thumb {
    background: var(--paper-grey-400);
  }
`;

export class KatapultScroll extends LitElement {
  static styles = css`
    ${ScrollbarStyle}

    :host {
      position: relative;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }

    #scroll {
      overflow: auto;
      display: flex;
      flex-direction: column;
      padding: 1em;
    }

    #shadowTop,
    #shadowBottom {
      position: absolute;
      left: 0;
      height: 16px;
      width: 100%;
      pointer-events: none;
      z-index: 1;
    }

    #shadowTop {
      top: 0;
      background: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0));
    }

    #shadowBottom {
      bottom: 0;
      background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.1));
    }
  `;

  render() {
    return html`
      <div id="shadowTop"></div>
      <div id="shadowBottom"></div>
      <div id="scroll" part="scroll" @scroll="${this._updateShadow}">
        <slot></slot>
      </div>
    `;
  }

  constructor() {
    super();

    this._resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.target == this._scroll) this._updateShadow();
      }
    });
  }

  firstUpdated() {
    this._scroll = this.renderRoot.querySelector('#scroll');
    this._resizeObserver.observe(this._scroll);
    this._shadowTop = this.renderRoot.querySelector('#shadowTop');
    this._shadowBottom = this.renderRoot.querySelector('#shadowBottom');
  }

  _updateShadow() {
    const scrollTop = this._scroll.scrollTop;
    const scrollBottom = this._scroll.scrollHeight - (scrollTop + this._scroll.offsetHeight);
    const scrollShadowHeight = this._shadowTop.offsetHeight;
    const scrollShadowTopOpacity = Clamp(scrollTop, 0, scrollShadowHeight) / scrollShadowHeight;
    const scrollShadowBottomOpacity = Clamp(scrollBottom, 0, scrollShadowHeight) / scrollShadowHeight;
    this._shadowTop.style.opacity = scrollShadowTopOpacity;
    this._shadowBottom.style.opacity = scrollShadowBottomOpacity;
  }
}

customElements.define('katapult-scroll', KatapultScroll);
